import React, { useState, useEffect } from "react";
import { API } from "../../config/api";

export default function AdsPlanManager() {
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({
    days: "",
    amount: "",
  });

  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  // ✅ Fetch Plans
  const fetchPlans = () => {
    fetch(API.GET_ADS_PLANS)
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setPlans(data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  // ✅ Handle Input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Add Plan
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.days || !form.amount) {
      alert("All fields required");
      return;
    }

    setLoading(true);

    try {
      const url = editId ? API.UPDATE_ADS_PLAN : API.ADD_ADS_PLAN;

      const payload = editId ? { ...form, id: editId } : form;

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        alert(editId ? "Plan Updated" : "Plan Added");

        setForm({
          days: "",
          amount: "",
        });

        setEditId(null);

        fetchPlans();
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  // ✅ Delete Plan
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this plan?")) return;

    try {
      const res = await fetch(API.DELETE_ADS_PLAN, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });

      const data = await res.json();

      if (data.status) {
        fetchPlans();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="workspace-container">
      <h2>Ads Plan Manager</h2>

      {/* ✅ Add Form */}
      <form onSubmit={handleSubmit} className="workspace-form">
        <div className="workspace-grid">
          <div className="workspace-field">
            <label>Days</label>
            <input
              type="number"
              name="days"
              value={form.days}
              onChange={handleChange}
              placeholder="Enter days (e.g. 7)"
            />
          </div>

          <div className="workspace-field">
            <label>Amount (₹)</label>
            <input
              type="number"
              name="amount"
              value={form.amount}
              onChange={handleChange}
              placeholder="Enter amount"
            />
          </div>
        </div>
        <div className="mt-4"></div>
        <button className="machine-submit-btn">
          {loading ? "Saving..." : editId ? "Update Plan" : "Add Plan"}
        </button>
      </form>

      {/* ✅ List */}
      <div style={{ marginTop: "30px" }}>
        <h3>All Plans</h3>
        <div className="ad-table-responsive">
          <table className="ad-table">
            <thead>
              <tr>
                <th>Days</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {plans.length === 0 && (
                <tr>
                  <td colSpan="3">No Plans Found</td>
                </tr>
              )}

              {plans.map((plan) => (
                <tr key={plan.id}>
                  <td>{plan.days}</td>
                  <td>₹{plan.amount}</td>
                  <td style={{ display: "flex", gap: "10px" }}>
                    <button
                      type="button"
                      className="ad-icon-btn ad-edit"
                      onClick={() => {
                        setForm({
                          days: plan.days,
                          amount: plan.amount,
                        });

                        setEditId(plan.id);
                      }}
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                      type="button"
                      className="ad-icon-btn ad-delete"
                      onClick={() => handleDelete(plan.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
